export default class User{
    constructor(){
        this.id=null;
        this.user_level_id = null;
        this.nickname = null;
        this.birthday = null;
        this.gender = null;
        this.email = null;
        this.password = null;
        this.state_account = null;
        this.confirmed = null;
        this.blocking_days = null;
        this.last_login = null;
        this.facebook = null;
        this.google = null;
        this.link_twitter = null;
        this.link_instagram = null;
        this.link_facebook = null;
        this.link_youtube = null;
        this.link_apoiase = null;
        this.link_padrim = null;
        this.link_patreon = null;
        this.link_site = null;
        this.description = null;
        this.country = null;
        this.estate = null;
        this.location = null;
        this.profile_photo = null;    
    }
}